import { type ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "@project/lib/i18n-config";

export function I18nProvider({ children }: { children: ReactNode }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
